type RenderArgs = {
  subject: string;
  bodyHtml: string;
  unsubscribeUrl: string;
  recipientName?: string;
  preheader?: string;
  trackingPixelUrl?: string;
  isMarketing?: boolean;
};

const FONT = `system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif`;

export function renderEmail({
  subject,
  bodyHtml,
  unsubscribeUrl,
  recipientName,
  preheader,
  trackingPixelUrl,
  isMarketing,
}: RenderArgs): string {
  const date = new Date().toLocaleDateString('en-US', {
    year: 'numeric', month: 'short', day: 'numeric',
  });
  const year = new Date().getFullYear();
  const greeting = recipientName ? `Hey ${escapeHtml(recipientName)},` : 'Hey,';
  const previewText = preheader || subject;
  const footerReason = isMarketing
    ? "You're receiving this marketing email from Atomic Rose Tools."
    : "You're receiving this because you signed up at";

  return `<!doctype html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width,initial-scale=1">
  <meta name="x-apple-disable-message-reformatting">
  <meta name="color-scheme" content="light dark">
  <meta name="supported-color-schemes" content="light dark">
  <title>${escapeHtml(subject)}</title>
  <style>
    @media (max-width:600px){
      .container{width:100% !important}
      .px{padding-left:20px !important;padding-right:20px !important}
    }
  </style>
</head>
<body style="margin:0;background:#0f172a;">
  <div style="display:none;max-height:0;overflow:hidden;">${escapeHtml(previewText)}</div>
  <table role="presentation" width="100%" cellspacing="0" cellpadding="0" style="background:#0f172a;" bgcolor="#0f172a">
    <tr><td align="center" style="padding:24px;">
      <table role="presentation" width="600" class="container" cellspacing="0" cellpadding="0" style="width:600px;">
        <tr><td class="px" style="padding:24px 32px;">
          <table role="presentation" width="100%" cellspacing="0" cellpadding="0">
            <tr>
              <td style="font:700 18px/1.2 ${FONT};color:#f8fafc;letter-spacing:.5px;">Atomic Rose Tools</td>
              <td align="right" style="font:500 12px/1 ${FONT};color:#94a3b8;">${date}</td>
            </tr>
          </table>
        </td></tr>

        <tr><td class="px" style="padding:0 32px 32px;">
          <table role="presentation" width="100%" cellspacing="0" cellpadding="0" style="background:#1e293b;border:1px solid #334155;border-radius:12px;">
            <tr><td style="padding:32px;color:#f8fafc;font:400 16px/1.6 ${FONT};">
              <p style="margin:0 0 16px;color:#94a3b8;"><strong>${greeting}</strong></p>
              ${bodyHtml}
            </td></tr>
          </table>
        </td></tr>

        <tr><td class="px" style="padding:0 32px 40px;">
          <table role="presentation" width="100%" cellspacing="0" cellpadding="0">
            <tr><td align="center" style="color:#94a3b8;font:500 12px/1.5 ${FONT};">
              ${footerReason}
              ${isMarketing ? '' : `<a href="https://atomic-rose.com" style="color:#94a3b8;text-decoration:underline;">atomic-rose.com</a>.`}<br>
              <a href="${unsubscribeUrl}" style="color:#94a3b8;text-decoration:underline;">Unsubscribe</a>
              &nbsp;·&nbsp; © ${year} Atomic Rose Tools
            </td></tr>
          </table>
        </td></tr>
      </table>
    </td></tr>
  </table>
  ${trackingPixelUrl ? `<img src="${escapeHtml(trackingPixelUrl)}" width="1" height="1" alt="" style="display:block;border:0" referrerpolicy="no-referrer">` : ''}
</body>
</html>`;
}

const HTML_ESCAPE: Record<string, string> = {
  '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
};
function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, (c) => HTML_ESCAPE[c]);
}

export function unsubscribePage(email: string): string {
  return `<!doctype html>
<html lang="en"><head>
<meta charset="UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1">
<title>Unsubscribed — Atomic Rose Tools</title>
<style>
  body{margin:0;background:#0f172a;color:#f8fafc;font:400 16px/1.6 ${FONT};display:flex;align-items:center;justify-content:center;min-height:100vh;padding:24px}
  .card{background:#1e293b;border:1px solid #334155;border-radius:12px;padding:40px;max-width:480px;text-align:center}
  h1{margin:0 0 12px;font-size:22px}
  p{margin:0 0 12px;color:#94a3b8}
  a{color:#0ea5e9}
</style></head>
<body><div class="card">
  <h1>You've been unsubscribed</h1>
  <p>${escapeHtml(email)} has been removed from the Atomic Rose Tools newsletter.</p>
  <p>Sorry to see you go. If this was a mistake, just <a href="https://atomic-rose.com">re-subscribe on atomic-rose.com</a>.</p>
</div></body></html>`;
}
